import WebFont from 'webfontloader';
import { fontState } from './state.js';

export default {
  install: (app, userOptions = {}) => {

    const options = {
      id: "xxxxxxx",
      src: 'typekit',
      ...userOptions
    };

    if (typeof window === 'undefined') return;

    if (options.src === 'typekit') {
      WebFont.load({
        typekit: { id: options.id },

        active() {
          fontState.loaded = true;
          window.dispatchEvent(new CustomEvent('fonts:loaded'));
        },

        inactive() {
          fontState.failed = true;
          window.dispatchEvent(new CustomEvent('fonts:failed'));
        }
      });
    }

    const fonts = { fontState };

    app.config.globalProperties.$fonts = fonts;
    app.provide('$fonts', fonts);
  }
}